import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { assignTrackerRows } from '../../../../../redux/features/tutorReplacementTrackerSlice';

// Hands one replacement to someone in the Talent Acquisitions or L&D Wing (same idea as SMO → SME).
export default function AssignDialogContent({ row, team = [], onClose, onSaved }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  // a row that is already assigned starts on its current assignee
  const [assignee, setAssignee] = useState(team.find((member) => member.userID === row.assignedTo) ?? null);
  const [remarks, setRemarks] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!assignee) {
      enqueueSnackbar('Select an employee to assign', { variant: 'warning' });
      return;
    }
    setSaving(true);
    const action = await dispatch(
      assignTrackerRows({ trainerAssignmentIds: [row.trainerAssignmentId], assignedTo: assignee.userID, remarks }),
    );
    setSaving(false);
    const ok = action.payload?.status === 'success';
    enqueueSnackbar(action.payload?.message || (ok ? 'Assigned' : 'Could not assign'), { variant: ok ? 'success' : 'error' });
    if (ok) onSaved();
  };

  return (
    <Stack gap={2} pt={1}>
      <Typography variant="body2" color="text.secondary">
        {`${row.studentName ?? '—'} · ${row.subjectName ?? '—'} (inactivated tutor: ${row.oldTutorName ?? '—'})`}
      </Typography>
      <Autocomplete
        options={team}
        value={assignee}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.userID === value.userID}
        onChange={(_, value) => setAssignee(value)}
        renderInput={(params) => <TextField {...params} label="Assign to" />}
      />
      <TextField label="Remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)} multiline minRows={2} inputProps={{ maxLength: 300 }} />
      <Stack direction="row" justifyContent="flex-end" gap={1}>
        <Button variant="outlined" color="inherit" onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? 'Please wait...' : 'Assign'}
        </Button>
      </Stack>
    </Stack>
  );
}
